import styled from "styled-components";
import { theme } from "../../styles/theme";
export const Card = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  background: ${theme.colors.white} 0% 0% no-repeat padding-box;
  box-shadow: 0px 9px 20px #00000008;
  border-radius: 15px;
  opacity: 1;
  padding: ${({ padding }) => padding};
`;

export const Bullet = styled.div`
  width: 6px;
  height: 6px;
  background: ${theme.colors.salmon} 0% 0% no-repeat padding-box;
  opacity: 1;
  border-radius: 50%;
`;
